import { useContext } from 'react'
import { NoteProcessorContext, NoteProcessorContextType } from './NoteProcessorProvider'

export function useNoteProcessor(): NoteProcessorContextType {
  const context = useContext(NoteProcessorContext)
  if (!context) {
    throw new Error(
      'useNoteProcessor must be used within NoteProcessorProvider'
    )
  }
  return context
}
